export default function TargetAudience() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6">
            Is This Right for You?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We work with serious business owners and individuals who are committed to doing things the right way
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 border border-gray-200 rounded-xl overflow-hidden">
          <div className="bg-white p-12 border-t-4 border-green-500">
            <h3 className="text-2xl font-bold text-navy mb-8">
              Who This Is For
            </h3>

            <ul className="space-y-5">
              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-xl text-green-500"></i>
                </div>
                <span className="text-base text-gray-700">
                  Business owners seeking strategic funding for growth
                </span>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-xl text-green-500"></i>
                </div>
                <span className="text-base text-gray-700">
                  Entrepreneurs building fundable business credit profiles
                </span>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-xl text-green-500"></i>
                </div>
                <span className="text-base text-gray-700">
                  Individuals with decent credit looking to optimize positioning
                </span>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-xl text-green-500"></i>
                </div>
                <span className="text-base text-gray-700">
                  Those willing to follow a structured process
                </span>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-xl text-green-500"></i>
                </div>
                <span className="text-base text-gray-700">
                  People who value compliance and long-term strategy
                </span>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-xl text-green-500"></i>
                </div>
                <span className="text-base text-gray-700">
                  Businesses ready to invest in proper positioning
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 p-12 border-t-4 border-gray-400 border-l border-gray-200">
            <h3 className="text-2xl font-bold text-charcoal mb-8">
              Who It's Not For
            </h3>

            <ul className="space-y-5">
              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-close-circle-fill text-xl text-gray-500"></i>
                </div>
                <span className="text-base text-gray-600">
                  Those looking for guaranteed approvals or quick fixes
                </span>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-close-circle-fill text-xl text-gray-500"></i>
                </div>
                <span className="text-base text-gray-600">
                  People seeking credit repair or score manipulation
                </span>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-close-circle-fill text-xl text-gray-500"></i>
                </div>
                <span className="text-base text-gray-600">
                  Those unwilling to provide proper documentation
                </span>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-close-circle-fill text-xl text-gray-500"></i>
                </div>
                <span className="text-base text-gray-600">
                  Individuals expecting overnight results
                </span>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-close-circle-fill text-xl text-gray-500"></i>
                </div>
                <span className="text-base text-gray-600">
                  Those looking for shortcuts or gray-area tactics
                </span>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-close-circle-fill text-xl text-gray-500"></i>
                </div>
                <span className="text-base text-gray-600">
                  People who won't commit to the full process
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
